<template>
  <header class="fixed inset-x-0 top-0 z-50">
    <nav class="navbar" :class="{'hidden-header' : hidden }">
      <router-link :to="{name: 'home'}"><img alt="TNS Télécom Nancy Service" :src="currentLogo" class="logo"></router-link>
      <div
        id="primary-navigation"
        class="navlinks"
        :class="{ hamburger: hamburger}"
        ref="menuPanel"
        :aria-hidden="isMobileViewport && !hamburger ? 'true' : null"
        :inert="isMobileViewport && !hamburger ? '' : null"
      >
        <ul style="width: 100%" class="items-center">
          <li v-if="hamburger" class="pb-10">
            <div class="absolute px-4 -translate-x-1/2 bg-transparent left-1/2">
              <img alt="TNS" src="/assets/images/tns_logo_icon_couleur.svg" class="h-10 w-10">
            </div>
          </li>
          <li>
            <router-link :to="{name: 'home'}" @click="closeHamburger">Accueil</router-link>
          </li>
          <li>
            <router-link :to="{name: 'prestations'}" @click="closeHamburger">
              Prestations
            </router-link>
          </li>

          <!-- 'Nous rejoindre' removed because /recrutement route was deleted -->

          <li>
            <router-link :to="{name: 'about'}" @click="closeHamburger">À propos</router-link>
          </li>
          <li>
            <router-link :to="{name: 'contact'}" @click="closeHamburger">Contact</router-link>
          </li>
        </ul>
      </div>
      <div class="desktop-theme-toggle">
        <ThemeToggle />
      </div>
      <button
        type="button"
        class="menu-hamburger"
        ref="hamburgerButton"
        :aria-expanded="hamburger"
        aria-haspopup="menu"
        aria-controls="primary-navigation"
        :aria-label="hamburger ? 'Fermer le menu' : 'Ouvrir le menu'"
        @click="toggleHamburger"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
          :class="['menu-hamburger-icon', { 'menu-hamburger-light': !isDark }]"
        >
          <path d="M24 6h-24v-4h24v4zm0 4h-24v4h24v-4zm0 8h-24v4h24v-4z"/>
        </svg>
      </button>
    </nav>
  </header>
</template>

<script>
import ThemeToggle from './ThemeToggle.vue'
import { useTheme } from '@/composables/useTheme'

export default {
  components: {
    ThemeToggle,
  },
  setup() {
    const { isDark } = useTheme()

    return {
      isDark,
    }
  },
  data() {
    return {
      hamburger: false,
      smallNavbar: false,
      hidden: false,
      lastScroll: 0,
      isMobileViewport: false,
      logoDark: '/assets/images/tns_logo_complet_blanc_fond_transparent_300ppp.png',
      logoLight: '/assets/images/tns_logo_complet_couleur_fond_transparent_72dpi.png',
    }
  },
  computed: {
    currentLogo() {
      return this.isDark ? this.logoDark : this.logoLight
    },
  },
   methods: {
     getMenuFocusableElements() {
       if (!this.$refs.menuPanel) {
         return []
       }

       return [...this.$refs.menuPanel.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])')]
     },
     handleScroll() {
      if (window.scrollY > 0) {
        this.hidden = window.scrollY >= this.lastScroll;
      } else {
        this.hidden = false;
      }
      this.lastScroll = window.scrollY;
    },
    handleResize() {
      this.isMobileViewport = window.matchMedia('(max-width: 900px)').matches

      if (!this.isMobileViewport && this.hamburger) {
        this.hamburger = false
        document.body.style.overflowY = 'auto'
      }
    },
    handleKeydown(event) {
      if (!this.hamburger) {
        return
      }

      if (event.key === 'Escape') {
        this.closeHamburger()
        return
      }

      if (event.key !== 'Tab') {
        return
      }

      const focusable = this.getMenuFocusableElements()
      if (!focusable.length) {
        event.preventDefault()
        this.$refs.hamburgerButton?.focus()
        return
      }

      const first = focusable[0]
      const last = focusable[focusable.length - 1]
      const current = document.activeElement

      if (event.shiftKey && current === first) {
        event.preventDefault()
        last.focus()
      } else if (!event.shiftKey && current === last) {
        event.preventDefault()
        first.focus()
      }
    },
    toggleHamburger() {
      if (this.hamburger) {
        this.closeHamburger()
        return
      }

      this.hamburger = true
      // désactiver le défilement vertical (overflow-y) lorsque le menu hamburger est ouvert
      document.body.style.overflowY = 'hidden'

      this.$nextTick(() => {
        const focusable = this.getMenuFocusableElements()
        focusable[0]?.focus()
      })
    },
    closeHamburger() {
      this.hamburger = false
      document.body.style.overflowY = 'auto'

      this.$nextTick(() => {
        this.$refs.hamburgerButton?.focus()
      })
    },

  },
   mounted() {
     window.addEventListener('scroll', this.handleScroll)
     window.addEventListener('resize', this.handleResize)
     window.addEventListener('keydown', this.handleKeydown);
     this.handleResize()
   },
   beforeUnmount() {
     window.removeEventListener('scroll', this.handleScroll)
     window.removeEventListener('resize', this.handleResize)
     window.removeEventListener('keydown', this.handleKeydown);
   },
}
</script>

<style scoped>
* {
  margin: 0;
  padding: 0;
  text-decoration: none;
  list-style: none;
}

img {
  background: none;
  border: none;
}

.hidden-header {
  transform: translateY(-100%);
}

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  padding: 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  height: 10px;
  box-sizing: border-box;
  background: rgba(23, 23, 23, 0.5);
  backdrop-filter: blur(3px);
  transition: all 300ms;
  border-bottom: 1px solid rgb(255, 255, 255, 0.2);
}

.navbar .logo {
  opacity: 100%;
  width: 170px;
  border-radius: 0;
  background: none;
  transition: all 0.2s ease;
}

.navbar li a {
  background: none;
  color: white;
  opacity: 50%;
  font-size: 20px;
  font-weight: 800;
  transition: all 0.2s ease;
}

.navbar a:hover {
  opacity: 100%;
}

.navbar .navlinks ul {
  display: flex;
  background: none;
}

.navbar .navlinks ul li {
  background: none;
  margin: 25px;
}

li {
  background: none;
}

.navbar .menu-hamburger {
  display: none;
  position: absolute;
  top: 10px;
  right: 10px;
  width: auto;
  padding: 0;
  border: 0;
  background: transparent;
  appearance: none;
  -webkit-appearance: none;
  cursor: pointer;
  line-height: 0;
}

.navbar .menu-hamburger:hover,
.navbar .menu-hamburger:active {
  background: transparent;
  border: 0;
  color: inherit;
}

.navbar .menu-hamburger:focus-visible {
  outline: 3px solid currentColor;
  outline-offset: 6px;
}

.menu-hamburger-icon {
  display: block;
  width: 45px;
}

.menu-hamburger-icon path {
  fill: white;
}

.menu-hamburger-light path {
  fill: black;
}

.desktop-theme-toggle {
  margin-left: 16px;
}

@media screen and (max-width: 900px) {
   .navbar {
     padding: 0;
     height: 70px;
   }

   .navlinks {
     top: 0;
     left: 0;
     position: absolute;
     width: 100%;
     height: 100vh;
     display: flex;
     justify-content: center;
     background: var(--background-color);
     margin-left: -100%;
     transition: all 0.5s ease;
     /* Off-screen navigation should not be keyboard-focusable */
     visibility: hidden;
   }

   .navlinks.hamburger {
     margin-left: 0;
     background-color: black;
     visibility: visible;
   }

  .navlinks ul {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .navbar .menu-hamburger {
    display: block;
    /* top: 50%; */
    right: 14px;
    transform: translateY(-50%);
  }

  .menu-hamburger-icon {
    width: 38px;
  }

  .desktop-theme-toggle {
    position: absolute;
    right: 62px;
    top: 38%;
    transform: translateY(-50%);
  }

  .navbar .navlinks ul li {
    margin: 25px 0;
  }

  .navbar .logo {
    /* position: absolute;
    top: 50px;
    left: 50px; */
    width: 110px;
    padding-left: 15px;
  }
}

:root {
  --background-color: #005c91;
  --background-color-transparent: rgba(23, 23, 23, 0.14);
  --vc-clr-primary: var(--background-color) !important;
  --vc-clr-secondary: rgb(180, 180, 180) !important;
  font-family: Raleway,serif;
  background: linear-gradient(rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)), url("../../public/assets/images/telecom_nancy_tns.jpg") center center/cover no-repeat fixed;
  /* TODO: Image non libre de droits */
}

h1 {
  text-align: center;
  padding: 5px;
  color: white;
}

h1 {
  padding: 50px;
}

h2 {
  text-align: center;
  color: rgb(159, 159, 159);
}

p {
  color: white;
}


button {
  background: var(--background-color);
  border: 2px solid var(--background-color);
  padding: 10px 20px;
  margin-top: 20px;
  color: white;
  border-radius: 20px;
  transition: all 0.2s ease;
  font-family: Raleway, serif;
  cursor: pointer;
}

button:hover {
  background: white;
  color: var(--background-color);
}


img {
  pointer-events: none;
  border-radius: 50%;
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>